import { FC, Fragment } from "react";

import { ThankYouEmailCard } from "../../rows/ThankYouEmailCard";
import { AutomatedCommunicationsFormData, RowKey } from "../../types";
import { buildFulfillmentRows } from "../shared/buildFulfillmentRows";

interface ShopRowsProps {
  hasPickupEmail: boolean;
  hasShippingEmail: boolean;
  openRow: RowKey | null;
  onToggleOpen: (row: RowKey) => void;
  defaultValues: AutomatedCommunicationsFormData;
  hasDate: boolean;
  hasLocation: boolean;
}

export const ShopRows: FC<ShopRowsProps> = ({
  hasPickupEmail,
  hasShippingEmail,
  openRow,
  onToggleOpen,
  defaultValues,
  hasDate,
  hasLocation,
}) => {
  const shared = { openRow, onToggleOpen };

  const rows: { key: RowKey; node: React.ReactNode }[] = [
    {
      key: "thank-you-email",
      node: (
        <ThankYouEmailCard
          {...shared}
          defaultContent={defaultValues.thankYouWinner.content}
          hasDate={hasDate}
          hasLocation={hasLocation}
        />
      ),
    },
    ...buildFulfillmentRows({ hasPickupEmail, hasShippingEmail, openRow, onToggleOpen, defaultValues }),
  ];

  return (
    <>
      {rows.map(({ key, node }) => (
        <Fragment key={key}>{node}</Fragment>
      ))}
    </>
  );
};
